type Scalar = boolean | number | string;

export function uniqueArraysMatch(array1: Scalar[], array2: Scalar[]): boolean {
    const set1 = new Set(array1);
    const set2 = new Set(array2);
    const sets = new Set([...array1, ...array2]);
    return set1.size === sets.size && set2.size === sets.size;
}
